module.exports = __webpack_public_path__ + "img/other-icon.89d26172.svg";